import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { IoMdAttach } from "react-icons/io";
import { Link } from "react-router-dom";
import PieceJointeModal from "../../../modal/admin/PieceJointeModal";
import { useGetRemboursementsQuery } from "../../../../utils/api/remboursement/remboursement.api";
import { useModal, usePagination, useSearch, useSelectSearch } from "../../../../utils/hooks";
import { IRemboursement, RemboursementType } from "../../../../utils/api/remboursement/remboursement.type";
import TableSkeleton from "../../../common/TableSkeleton";
import {
	formatMontant,
	formatRemboursementStatus,
	formatRemboursementStatusClass,
	formattedDate,
	isShowPagination,
	isValidRemboursement,
} from "../../../../utils/utils";
import { CustomPagination } from "../../../common/CustomPagination";
import { DeleteRemboursement, ValidRemboursement } from "./ListeHospitalisationsTable";
import ChangeStatusRemboursementModal from "./ChangeStatusRemboursementModal";
import { ButtonEdit, ButtonViewLink } from "../../../common/Button";
import AddRemboursementModal from "../../../modal/admin/AddRemboursementModal";
import moment from "moment";
import filterFactory, { customFilter } from "react-bootstrap-table2-filter";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from "date-fns/locale/fr";
import { InputFilter } from "../../../common/Input";
import { SelectInputFilter } from "../../../common/SelectInput";
import { statusList } from "./Remboursements";
registerLocale("fr", fr);

const modalId = "ChangeStatusRemboursementModalApp";

function ListeAppareilsTable() {
	const [date, setDate] = useState<Date>();

	const { search: nom, handlefilter } = useSearch();
	const { search: appareils, handlefilter: handlefilterAppareil } = useSearch();
	const { search: prenom, handlefilter: handlefilterPrenom } = useSearch();
	const { search: matricule, handlefilter: handlefilterMatricule } = useSearch();
	const { search: status, handlefilter: handleFilterByStatus } = useSelectSearch();
	const { page, setPage, limit, setPerPage } = usePagination(10);
	const { data = { results: [] }, isLoading } = useGetRemboursementsQuery({
		page,
		limit,
		type_remboursement: "appareils",
		nom,
		date: date ? moment(date).format("DD-MM-YYYY") : undefined,
		matricule,
		appareils,
		prenom,
		status,
	});

	const { item, getItem, resetItem, openEditModal } = useModal<IRemboursement>();

	const actionFormatter = (cell: string, row: IRemboursement) => {
		return (
			<>
				<div className="table-actions-btn-container-commandes d-flex gap-3">
					<ValidRemboursement item={row} />
					<ButtonViewLink to={`${row?.slug}`} state={row} />
					<div className="container-btn-action-icon-modal">
						<button
							className="btn btn-action-modal-icon with-tooltip"
							data-tooltip-content="Justificatif"
							data-bs-toggle="modal"
							data-bs-target="#PieceJointeModal"
							onClick={() => getItem(row)}
						>
							<IoMdAttach />
						</button>
					</div>
					{isValidRemboursement(row) ? (
						<>
							{/* <button
								className="btn btn-action-modal-icon with-tooltip"
								data-tooltip-content="Modifier"
								type="button"
								disabled
							>
								<MdModeEdit />
							</button> */}
						</>
					) : (
						<ButtonEdit
							data-bs-toggle="modal"
							data-bs-target="#AddRemboursementAppareilModal"
							onClick={() => openEditModal(row)}
						/>
					)}
					<DeleteRemboursement item={row} />
				</div>
			</>
		);
	};
	const patientFormatter = (cell: string, row: IRemboursement) => {
		return (
			<Link to={`/admin/utilisateur/${row?.patient?.slug}`} state={row?.patient}>
				{cell}
			</Link>
		);
	};
	const statutFormatter = (cell, row) => {
		return (
			<div className="table-actions-btn-container-img d-flex align-items-center">
				<span
					className={`statut-dossier-item text-capitalize ${formatRemboursementStatusClass(cell)}`}
					role="button"
					onClick={() => getItem(row)}
					data-bs-toggle="modal"
					data-bs-target={`#${modalId}`}
				>
					{formatRemboursementStatus(cell)}
				</span>
			</div>
		);
	};

	const columns = [
		{
			dataField: "matricule",
			text: "Matricule",
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="matricule" placeholder="Entrer un matricule" onChange={handlefilterMatricule} />,
		},
		{
			dataField: "patient.prenom",
			text: "Prénom",
			formatter: (cell: string, row: IRemboursement) => patientFormatter(cell, row),
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="prenom" placeholder="Entrer un prénom" onChange={handlefilterPrenom} />,
		},
		{
			dataField: "patient.nom",
			text: "Nom",
			formatter: (cell: string, row: IRemboursement) => patientFormatter(cell, row),
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="nom" placeholder="Entrer un nom" onChange={handlefilter} />,
		},
		{
			dataField: "montant",
			text: "Montant",
			formatter: (cell: string) => formatMontant(cell),
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="montant" placeholder="Entrer un montant" onChange={handlefilter} />,
		},
		{
			dataField: "appareils",
			text: "Appareils",
			filter: customFilter(),
			filterRenderer: () => (
				<InputFilter
					id="appareils"
					placeholder="Entrer un appareil"
					onChange={handlefilterAppareil}
					defaultValue={appareils}
				/>
			),
		},

		{
			dataField: "created_at",
			text: "Date",
			formatter: (cell: string) => formattedDate(cell),
			filter: customFilter(),
			filterRenderer: () => (
				<div className="date-picker-container">
					<DatePicker
						className="form-control tab-dash-admin-filter-input"
						selected={date}
						onChange={(date: Date) => setDate(date)}
						maxDate={new Date()}
						dateFormat="dd/MM/yyyy"
						placeholderText="Choisir une date"
						isClearable
						locale="fr"
					/>
				</div>
			),
		},
		{
			dataField: "status",
			text: "Statut",
			formatter: (cell: string, row: IRemboursement) => statutFormatter(cell, row),
			filter: customFilter(),
			filterRenderer: () => (
				<SelectInputFilter id="motif" placeholder="Statut" onChange={handleFilterByStatus} options={statusList} />
			),
		},
		{
			dataField: "id",
			text: "Actions",
			style: { textAlign: "center" },
			formatter: (cell: string, row: IRemboursement) => actionFormatter(cell, row),
		},
	];

	return (
		<>
			{isLoading && <TableSkeleton headers={columns} />}
			{!isLoading && (
				<>
					<BootstrapTable
						keyField="slug"
						data={data?.results}
						columns={columns}
						bordered={true}
						condensed={false}
						responsive={true}
						wrapperClasses="table-responsive admin-table"
						noDataIndication={() => "Aucune donnée trouvée"}
						filter={filterFactory()}
						filterPosition="inline"
					/>
					{isShowPagination(data?.count || 0) && (
						<CustomPagination
							nbPages={data?.count}
							page={page}
							onChange={(page, limit) => {
								setPerPage(limit);
								setPage(page);
							}}
							perPage={limit}
						/>
					)}
				</>
			)}
			<div className="modal fade" id="PieceJointeModal" aria-labelledby="PieceJointeModalLabel" aria-hidden="true">
				<PieceJointeModal item={item} />
			</div>
			<ChangeStatusRemboursementModal modalId={modalId} item={item} />
			<div
				className="modal fade"
				id="AddRemboursementAppareilModal"
				aria-labelledby="AddRemboursementModalLabel"
				aria-hidden="true"
			>
				<AddRemboursementModal
					resetItem={resetItem}
					item={item}
					currentType={RemboursementType.appareils}
					modalId="AddRemboursementAppareilModal"
				/>
			</div>
		</>
	);
}

export default ListeAppareilsTable;
